/**
 * Utilitários para cálculos de Fecho de Turno
 */

// Valores das raspadinhas disponíveis
export const VALORES_RASPADINHAS = [1, 2, 3, 5, 10, 15];

/**
 * Calcula o valor total de raspadinhas vendidas
 */
export const calcularValorRaspadinhas = (fecho) => {
  return VALORES_RASPADINHAS.reduce((total, valor) => {
    const stock = fecho[`stock_${valor}`] || 0;
    const recepcao = fecho[`recepcao_${valor}`] || 0;
    const sFinal = fecho[`s_final_${valor}`] || 0;
    const vendidas = stock + recepcao - sFinal;
    return total + (vendidas * valor);
  }, 0);
};

/**
 * Calcula a diferença entre caixa esperado e real
 */
export const calcularDiferencaFecho = (fecho) => {
  const valorVendaRaspadinhas = calcularValorRaspadinhas(fecho);
  
  const caixaInicial = fecho.caixa_inicial_1 || 0;
  const vendas = fecho.premios_master_1_15 || 0;
  const premios = fecho.premios_total || 0;
  
  // Calcular dinheiro das revendas a partir da comissão guardada
  const comissaoRevendas = fecho.comissao_revendas || 0;
  const dinheiroRevendas = comissaoRevendas > 0 ? (comissaoRevendas / 0.05) * 0.95 : 0;
  
  // Fórmula: Caixa Inicial + Raspadinhas Vendidas + Vendas - Prémios + Dinheiro Revendas
  const totalExpectavel = caixaInicial + valorVendaRaspadinhas + vendas - premios + dinheiroRevendas;
  const caixaFinal = fecho.caixa_final || fecho.caixa_inicial_2 || 0;
  const diferenca = caixaFinal - totalExpectavel;
  
  // Arredondar e tratar valores muito pequenos como zero
  return Math.abs(diferenca) < 0.01 ? 0 : Math.round(diferenca * 100) / 100;
};

/**
 * Formata valor em moeda EUR
 */
export const formatCurrency = (value) => {
  const num = Number(value) || 0;
  return new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: 'EUR'
  }).format(num);
};

/**
 * Determina a cor da diferença baseada no valor
 */
export const getCorDiferenca = (diferenca) => {
  if (Math.abs(diferenca) <= 0.01) return 'text-green-600';
  if (diferenca > 0) return 'text-green-600';
  return 'text-destructive';
};

/**
 * Calcula valores ajustados subtraindo manhã se for tarde
 */
export const getValoresAjustados = (fecho, fechoManha = null) => {
  let vendas = fecho?.premios_master_1_15 || 0;
  let premios = fecho?.premios_total || 0;
  
  // Se for tarde e tiver fecho da manhã, subtrair
  if (fecho?.turno?.toLowerCase().includes('tarde') && fechoManha) {
    const vendasManha = fechoManha.premios_master_1_15 || 0;
    const premiosManha = fechoManha.premios_total || 0;
    vendas = vendas - vendasManha;
    premios = premios - premiosManha;
  }
  
  return { vendas, premios };
};
